/* global self */

'use strict'

module.exports = self.crypto || self.msCrypto
